import moment from "moment"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import DatePicker from "../../../../../../_shared/components/FormItems/AdminDatePicker"
import AppInput from "../../../../../../_shared/components/FormItems/AppInput"
import StyledAppSelect from "../../../../../../_shared/components/FormItems/AppSelect"
import AppSwitch from "../../../../../../_shared/components/FormItems/AppSwitch"
import AppHeading from "../../../../../../_shared/components/Typography/Heading"
import MarkupEditor from "../../../../../../_shared/components/WYSIWYGEditor"

// ----------------------------------------------------------------------------

function BioForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { values, onValueChange, eventTypes } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <AppHeading className="heading" boldness="bold">
                Tipologia di evento
            </AppHeading>
            <StyledAppSelect
                className="duration"
                options={eventTypes?.map((t) => ({
                    label: t.name,
                    value: t.id,
                }))}
                value={
                    values?.eventType?.id
                        ? values?.eventType?.id
                        : values?.eventType
                }
                onChange={!values?.id ? onValueChange("eventType") : undefined}
                disabled={!!values?.id}
            ></StyledAppSelect>
            <AppSwitch
                className="switch"
                value={values?.bookingsOpen}
                onChange={onValueChange("bookingsOpen")}
                label="Prenotazioni aperte"
            />
            <AppSwitch
                className="switch"
                value={values?.published}
                onChange={onValueChange("published")}
                label="Evento visibile"
            />
            <AppSwitch
                className="switch"
                value={values?.private}
                onChange={onValueChange("private")}
                label="Evento privato"
            />
            <AppHeading className="heading" boldness="bold">
                Data di pubblicazione automatica
            </AppHeading>
            <DatePicker
                className="duration"
                value={
                    values?.autoPublishDate
                        ? moment(values?.autoPublishDate)
                        : null
                }
                onChange={(v) =>
                    onValueChange("autoPublishDate")(v?.toISOString())
                }
                showTime
                format="D MMM YYYY HH:mm"
            />

            <AppHeading className="heading" boldness="bold">
                Titolo
            </AppHeading>
            <MarkupEditor
                value={values?.title || ""}
                onChange={onValueChange("title")}
                placeholder="Titolo"
            />

            <AppHeading className="heading" boldness="bold">
                Descrizione breve
            </AppHeading>
            <MarkupEditor
                value={values?.summary || ""}
                onChange={onValueChange("summary")}
                placeholder="Summary"
            />
            <AppHeading className="heading" boldness="bold">
                Descrizione
            </AppHeading>
            <MarkupEditor
                value={values?.description || ""}
                onChange={onValueChange("description")}
                placeholder="Descrizione"
            />
            <AppHeading className="heading" boldness="bold">
                Prezzo
            </AppHeading>
            <AppInput
                className="duration"
                placeholder="evento gratuito"
                type="number"
                value={values?.price}
                onChange={onValueChange("price")}
            />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

BioForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onValueChange: PropTypes.func,
    eventTypes: PropTypes.array,
}

BioForm.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledBioForm = styled(BioForm)`
    & {
        .heading {
            margin-top: 30px;
        }
        .duration {
            width: 300px;
        }
        .switch {
            margin-top: 30px;
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledBioForm
